export const HeaderElements = {
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
};
export const TextElements = Object.assign({ Div: 'div', Span: 'span', P: 'p', Label: 'label', Li: 'li', Legend: 'legend', DescriptionTerm: 'dt', DescriptionDetails: 'dd' }, HeaderElements);
export const TextAlign = {
    Left: 'left',
    Center: 'center',
    Right: 'right',
    Start: 'start',
    End: 'end',
    Justify: 'justify',
    JustifyAll: 'justify-all',
    MatchParent: 'match-parent',
};
export const TextVerticalAligns = {
    Baseline: 'baseline',
    Sub: 'sub',
    Super: 'super',
    TextTop: 'text-top',
    TextBottom: 'text-bottom',
    Middle: 'middle',
    Top: 'top',
    Bottom: 'bottom',
};
//# sourceMappingURL=types.js.map